"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _default = function _default(_ref) {
  var onBack = _ref.onBack,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-24 px-32"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-16 h-16 absolute mt-4 ml-4 top-0 left-0 shadow-lg flex items-center justify-center rounded-full cursor-pointer dark:bg-secondary",
    onClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null)), /*#__PURE__*/_react["default"].createElement("div", null, children));
};

exports["default"] = _default;
//# sourceMappingURL=FullScreenLayout.js.map